import { invariant } from "@epic-web/invariant";
import { useRouteLoaderData } from "react-router";

import type { loader } from "~/root";

export const useRootLoaderData = () => {
  const rootLoaderData = useRouteLoaderData<typeof loader>("root");
  invariant(rootLoaderData, "Root loader data is required");
  return rootLoaderData;
};
